export const linkStyles = {
  base: `
    transition-all
    no-underline
  `,
  inline: {
    base: `
      font-normal
      text-primary
      hover:text-primary-lighter
      active:text-default-500
      focus:outline-2
      focus:outline-offset-2
      focus:outline-primary-600

    `,
  },
  header: {
    base: `
      font-bold
      text-default-50
    `,
  },
}
